import { Link } from "react-router-dom";
import { useData } from "../../hooks/useData";

// Renders the brand logo image from site.json if provided, else styled text.
export default function Logo({ className = "text-xl", testId }) {
  const { data: site } = useData("site");
  const name = site?.siteName || "utipanagecy";

  return (
    <Link to="/" className={`font-bold font-display tracking-tight ${className}`} data-testid={testId}>
      {site?.logo ? (
        <img src={site.logo} alt={name} className="h-8 w-auto" />
      ) : (
        <span className="text-gradient">{name}</span>
      )}
    </Link>
  );
}
